import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card } from '../components/ui/card';
import Logo from '../components/ui/logo';
import Icon from '../components/ui/icon';

const Login: React.FC = () => {
  const { login, isLoading, error } = useAuth();
  const [credentials, setCredentials] = useState({
    outlet_id: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(credentials);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 shadow-xl">
        <div className="text-center mb-8">
          <Logo className="mx-auto" size="xxl" />
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Pango Smart Outlet
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Đăng nhập để sử dụng trợ lý AI cho cửa hàng!
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-3"> 
            <label htmlFor="outlet_id" className="block text-md font-semibold text-gray-700 dark:text-gray-300">
              Mã cửa hàng
            </label>
            <Input
              id="outlet_id"
              name="outlet_id"
              type="text"
              value={credentials.outlet_id}
              onChange={handleInputChange}
              placeholder="Nhập mã cửa hàng"
              required
              size="lg"
            />
          </div>

          <div className="space-y-3">
            <label htmlFor="password" className="block text-md font-semibold text-gray-700 dark:text-gray-300">
              Mật khẩu
            </label>
            <div className="relative">
              <Input
                id="password"
                name="password"
                type={showPassword ? "text" : "password"}
                value={credentials.password}
                onChange={handleInputChange}
                placeholder="Nhập mật khẩu"
                required
                size="lg"
                className="pr-12"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
              >
                <Icon 
                  name={showPassword ? "eye-off" : "eye"} 
                  className="w-5 h-5" 
                />
              </button>
            </div>
          </div>

          <div className="flex w-full items-center justify-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">  
              Liên hệ <a href="mailto:lee@pbytetech.io" className="text-blue-500 hover:text-blue-700">Pango</a> để được cấp tài khoản trải nghiệm!
            </p>
          </div>


          {error && (
            <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
              <p className="text-red-600 dark:text-red-400 text-sm">{error}</p>
            </div>
          )}

          <Button
            type="submit"
            disabled={isLoading}
            size="lg"
            className="w-full"
          >
            {isLoading ? 'Đang đăng nhập...' : 'Đăng nhập'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">  
            @ 2025 Pango Smart Outlet. All rights reserved.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default Login;
